import * as React from 'react';
import { get, find } from 'lodash';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import MosaicTile from './mosaic_tile';
import {
  CoreMosaicTilesHomepage,
  core_apimessages_MosaicTilePosition as MosaicTilePositionEnum,
} from '../../../schemas/rql';

function PlaceholderTile() {
  return (
    <li className="mosaic-tile mosaic-tile--loading">
      <div className="mosaic-tile__link">
        <div className="mosaic-tile__image" />
        <div className="mosaic-tile__text">
          <div className="mosaic-tile__subtitle" />
          <div className="mosaic-tile__title" />
        </div>
      </div>
    </li>
  );
}

export function HomepageMosaic({ data }: ChildProps<{}, CoreMosaicTilesHomepage.Query>) {
  const tiles = get(data, 'mosaicTilesHomepage.mosaicTiles');
  const getTile = position => find(tiles, ['position', position]);

  if (data.loading) {
    return (
      <div className="mosaic-tiles">
        <ul className="mosaic-tiles__inner">
          <PlaceholderTile />
          <PlaceholderTile />
          <PlaceholderTile />
        </ul>
      </div>
    );
  }

  if (!tiles) return null;

  return (
    <div className="mosaic-tiles">
      <ul className="mosaic-tiles__inner">
        <MosaicTile tile={getTile(MosaicTilePositionEnum.LEFT)} />
        <MosaicTile tile={getTile(MosaicTilePositionEnum.CENTER)} />
        <MosaicTile tile={getTile(MosaicTilePositionEnum.RIGHT)} />
      </ul>
    </div>
  );
}

const withQuery = graphql<{}, CoreMosaicTilesHomepage.Query>(
  gql`
    query Core_MosaicTilesHomepage {
      mosaicTilesHomepage {
        mosaicTiles {
          id
          url
          imageUrl
          position
          imageTitle
          imageSubtitle
          contentSponsorship {
            sponsorshipType
            partnershipName
          }
        }
      }
    }
  `,
);

export default withQuery(HomepageMosaic);



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_mosaic.tsx